/** `?tab=` value that opens the "Manage subscriptions" tab on /account (used by the header subscription badge). */
export const SUBSCRIPTION_TAB_PARAM = 'subscription';
